import IngredientCostRepository from '@/utils/API/IngredientCostRepository'

export enum AddOnType {
    RecipeCost, SugarAlcohols, FieldEagle, WellnessModule, AllergenAI, DownloadLabels, CustomIngredientImport
}
